export const VIEW_FAQ = "VIEW_FAQ"
export const VIEW_FAQ_SUCCESS = "VIEW_FAQ_SUCCESS"
export const VIEW_FAQ_FAILED = "VIEW_FAQ_FAILED"